export default {
  title: 'Import jest w toku... 🙂',
  description: 'Powiadomienia Slack zostaną wysłane po zakończeniu importu.',
  buttons: {
    open_followers_list: 'Otwórz listę obserwujących',
  },
};
